export default{
    methods:{
    get_scroll_axis(container) {
      if (!container) return "horizontal";

      const has_horizontal_scroll =
        container.scrollWidth > container.clientWidth;
      const has_vertical_scroll =
        container.scrollHeight > container.clientHeight;

      if (has_horizontal_scroll) {
        return "horizontal";
      }

      if (has_vertical_scroll) {
        return "vertical";
      }

      return "horizontal";
    },
    get_wrapper_center_offset(child, container_rect, is_vertical) {
      const rect = child.getBoundingClientRect();
      const wrapper_center = is_vertical
        ? rect.top + (rect.height / 2)
        : rect.left + (rect.width / 2);
      const container_center = is_vertical
        ? container_rect.top + (container_rect.height / 2)
        : container_rect.left + (container_rect.width / 2);
      const offset = Math.abs(wrapper_center - container_center);
      return offset;
    },

    handle_scroll() {
      const container = this.$refs.carousel;
      if (!container) return;

      const containerRect = container.getBoundingClientRect();
      const children = Array.from(container.querySelectorAll('.form-wrapper'));
      if (!children.length) return;

      const scroll_axis = this.get_scroll_axis(container);
      const is_vertical = scroll_axis === "vertical";

      let best_index = this.current_section_index || 0;
      let best_offset = Number.POSITIVE_INFINITY;

      children.forEach((child, index) => {
        const offset = this.get_wrapper_center_offset(
          child,
          containerRect,
          is_vertical
        );
        if (offset < best_offset) {
          best_offset = offset;
          best_index = index;
        }
      });

      if (best_index !== this.current_section_index) {
        this.current_section_index = best_index;
      }
    },

    // Add this method to your methods object
    scroll_to_section_centered(index) {
      const container = this.$refs.carousel;
      if (!container) return;

      const targetSection = container.querySelector(`.form-wrapper[data-index="${index}"]`);
      if (!targetSection) return;

      const scroll_axis = this.get_scroll_axis(container);
      const isVertical = scroll_axis === "vertical";
      const scroll_options = { behavior: 'smooth' };

      if (isVertical) {
        const target_top = targetSection.offsetTop;
        const centered_top = target_top -
          ((container.clientHeight - targetSection.offsetHeight) / 2);
        scroll_options.top = Math.max(0, centered_top);
      } else {
        const target_left = targetSection.offsetLeft;
        const centered_left = target_left -
          ((container.clientWidth - targetSection.offsetWidth) / 2);
        scroll_options.left = Math.max(0, centered_left);
      }

      container.scrollTo(scroll_options);

      // Update current section index
      this.current_section_index = index;

    },

     scroll_to_section(index) {
      const container = this.$refs.carousel;
      if (container) {
        this.scroll_to_section_centered(index);
      }
    },

    observe_sections() {
      if (!this.$refs.carousel) return;

      // cleanup previous observer if any
      if (this._observer) {
        try { this._observer.disconnect(); } catch (e) { /* ignore */ }
        this._observer = null;
      }

      const options = {
        root: this.$refs.carousel,
        threshold: [0.25, 0.5, 0.75]
      };

      this._observer = new IntersectionObserver(() => {
        this.handle_scroll();
      }, options);

      const sections = this.$refs.carousel.querySelectorAll('.form-wrapper');
      if (!sections || sections.length === 0) return;

      sections.forEach((section, index) => {
        section.dataset.index = index;
        this._observer.observe(section);
      });
    },

    // attach / detach scroll listeners (call after DOM is ready)
    attachCarouselListeners() {
      const carousel = this.$refs.carousel;
      if (!carousel) return;

      // debounce helpers
      this._scrollRaf = null;
      this._touchTimeout = null;
      this._resizeTimeout = null;

      // scroll (RAF) and touchend fallback
      const onScroll = () => {
        if (this._scrollRaf) cancelAnimationFrame(this._scrollRaf);
        this._scrollRaf = requestAnimationFrame(() => {
          this.handle_scroll();
          this._scrollRaf = null;
        });
      };

      const onTouchEnd = () => {
        if (this._touchTimeout) clearTimeout(this._touchTimeout);
        this._touchTimeout = setTimeout(() => {
          this.handle_scroll();
          this._touchTimeout = null;
        }, 80); // small delay to allow inertia to finish
      };

      const onResize = () => {
        if (this._resizeTimeout) clearTimeout(this._resizeTimeout);
        this._resizeTimeout = setTimeout(() => {
          this.handle_scroll();
          this._resizeTimeout = null;
        }, 120);
      };

      // keep references so we can remove later
      this._carouselListeners = { onScroll, onTouchEnd, onResize };

      carousel.addEventListener('scroll', onScroll, { passive: true });
      carousel.addEventListener('touchend', onTouchEnd, { passive: true });
      window.addEventListener('resize', onResize);
    },

     // cleanup (call in beforeUnmount)
    detachCarouselListeners() {
      const carousel = this.$refs.carousel;
      if (!carousel || !this._carouselListeners) return;
      const { onScroll, onTouchEnd, onResize } = this._carouselListeners;
      carousel.removeEventListener('scroll', onScroll);
      carousel.removeEventListener('touchend', onTouchEnd);
      window.removeEventListener('resize', onResize);

      if (this._scrollRaf) { cancelAnimationFrame(this._scrollRaf); this._scrollRaf = null; }
      if (this._touchTimeout) { clearTimeout(this._touchTimeout); this._touchTimeout = null; }
      if (this._resizeTimeout) { clearTimeout(this._resizeTimeout); this._resizeTimeout = null; }

      this._carouselListeners = null;
    }

    }
}
